import * as React from 'react';
export const amexSvg = React.forwardRef(function amexSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.062 8.056 16 6h-2.584l-.7.778L12.124 6H9.143v.556h2.766l.807 1 .916-1h.968l-1.4 1.5 1.4 1.387h-.968l-.916-.999-.838 1H9.143V10h2.981l.592-.778.7.778H16l-1.938-1.944Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.863 8.889h1.615l.754-.833-.646-.834H9.863v.556h1.508v.555H9.863v.556Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.453 9.333 2.23 10H0l1.895-4h1.789l.218.444V6h2.23l.446 1.111L7.024 6h2.119v4H7.465v-.556L7.247 10H5.91l-.223-.556V10H3.233l-.223-.667h-.557Zm5.463.111h.665l.004-2.888H7.47l-.892 2-.892-2H4.571v2.666L3.233 6.556h-.892L1.003 9.444h.781l.223-.666h1.45l.222.666H5.24V7.222l1.004 2.222h.669l1.003-2.222v2.222ZM3.233 8.222 2.787 7 2.23 8.222h1.003Z',
    }),
  );
});
amexSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var amex = {
  category: 'paymentmethod',
  colorable: true,
  name: 'amex',
  svg: amexSvg,
};
